// extracted by mini-css-extract-plugin
module.exports = {"navBar":"FooterNavBar_navBar__2n-wb","navItem":"FooterNavBar_navItem__wMIav","navLink":"FooterNavBar_navLink__2rApa"};